import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogForm,
  DialogHeading,
  SubmitButton,
} from 'omakase';
import { PreVisitQuestionsFields } from '@tock/shared/utils/questionUtils';
import { PreVisitQuestionsFieldset } from 'forms/previsit-questions/PreVisitQuestionsFieldset';
import { QuestionnaireMessage } from 'forms/previsit-questions/QuestionnaireMessage';
import {
  body,
  formContainer,
} from 'components/business/receipts/ReceiptPreVisitQuestionDialog/preVisitQuestionDialogCssDefs';
import { consumer, core } from '@tock/coretypes';
import { useFormikContext } from 'formik';

interface ProfilePreVisitQuestionFormBodyProps {
  business: consumer.IBusinessConfig;
  questions: core.TicketTypeQuestion[];
  questionnaireIntroText?: core.TicketTypeDetails['questionnaireIntroText'];
  onClose(): void;
}

export const ProfilePreVisitQuestionFormBody = ({
  business,
  questionnaireIntroText,
  questions,
  onClose,
}: ProfilePreVisitQuestionFormBodyProps) => {
  const { isSubmitting, isValid } = useFormikContext<PreVisitQuestionsFields>();

  return (
    <Dialog
      aria-labelledby="survey-dialog-title"
      aria-describedby="survey-dialog-description"
      open
      data-testid="survey-dialog"
    >
      <DialogForm>
        <DialogHeading>Pre-visit questions</DialogHeading>
        <DialogContent id="survey-dialog-description" disablePadding css={body}>
          <div css={formContainer}>
            {questionnaireIntroText && (
              <QuestionnaireMessage business={business} message={questionnaireIntroText} />
            )}
            <PreVisitQuestionsFieldset questions={questions} />
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={onClose}
            size="medium"
            variant="ghost"
            fullWidth
            data-testid="survey-cancel-button"
          >
            Cancel
          </Button>
          <SubmitButton
            size="medium"
            variant="primary"
            fullWidth
            isSubmitting={isSubmitting}
            disabled={!isValid}
            data-testid="survey-submit-button"
          >
            Submit
          </SubmitButton>
        </DialogActions>
      </DialogForm>
    </Dialog>
  );
};
